import React from "react";
import { useNavigate } from "react-router-dom";

const ConfigurationMenu = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/expense-form");
  };

  return (
    <div className="configuration-menu">
      <h3>Configuration Menu</h3>
      <button onClick={handleNavigate}>Manage Expense Form</button>
    </div>
  );
};

export default ConfigurationMenu;